import { RouteConfig } from 'vue-router';
const Folder = () => import('./views/folder.vue');
const EditCeping = () => import('../common/edit-ceping.vue');
const EditCeping2 = () => import('./views/edit-ceping2.vue');
const EditCepingGroup = () => import('./views/edit-ceping-group.vue');
const SizhenAdd = () => import('./views/sizhen-add.vue');
const EditWen = () => import('./views/edit-wen.vue');
const EditTizhi = () => import('./views/edit-tizhi.vue');
const EditAIBianzheng = () => import('./views/edit-AI-bianzheng.vue');
const EditAITzcp = () => import('./views/edit-AI-tzcp.vue');
const routers: RouteConfig[] = [
    {
        path: 'folder',
        name: 'folder',
        component: Folder
    },
    {
        path: 'edit-ceping',
        name: 'edit-ceping',
        component: EditCeping
    },
    {
        path: 'edit-ceping2',
        name: 'edit-ceping2',
        component: EditCeping2
    },
    {
        path: 'edit-wen',
        name: 'edit-wen',
        component: EditWen
    },
    {
        path: 'edit-tizhi',
        name: 'edit-tizhi',
        component: EditTizhi
    },
    {
        path: 'edit-AI-bianzheng',
        name: 'edit-AI-bianzheng',
        component: EditAIBianzheng
    },
    {
        path: 'edit-AI-tzcp',
        name: 'edit-AI-tzcp',
        component: EditAITzcp
    },
    {
        path: 'edit-ceping-group',
        name: 'edit-ceping-group',
        component: EditCepingGroup
    },
    {
        path: 'sizhen-add',
        name: 'sizhen-add',
        component: SizhenAdd
    },
    {
        path: '',
        redirect: 'folder'
    },
];
export default routers;

